import { render, staticRenderFns } from "./medicineManage.vue?vue&type=template&id=85af89a4"
import script from "./medicineManage.vue?vue&type=script&lang=js"
export * from "./medicineManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85af89a4')) {
      api.createRecord('85af89a4', component.options)
    } else {
      api.reload('85af89a4', component.options)
    }
    module.hot.accept("./medicineManage.vue?vue&type=template&id=85af89a4", function () {
      api.rerender('85af89a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/medicineManage.vue"
export default component.exports